import React from 'react'
import {ReplayHighlightData, ReplaySlider} from './ReplaySlider'
import {AvatarList} from './AvatarList'
import {ControlButton} from './ControlButton'
import styles from './ReplayControlsContent.module.scss'
import clsx from 'clsx'
import IconRewind from '@static/images/icon_rewind.svg'
import IconPause from '@static/images/icon_pause.svg'
import IconPlay from '@static/images/icon_play.svg'
import IconFastForward from '@static/images/icon_forward.svg'
import {GameClientUserState} from '@colonist/game-base-types'
import {PlayerColor} from '@colonist/game-states'
import {T} from '@colonist/ui'

export interface UIGameReplayControlsContentMinimalProps {
    isPlaying: boolean
    onPreviousAction: VoidFunction
    onTogglePlayback: VoidFunction
    onNextAction: VoidFunction
    currentPlayerPerspective: PlayerColor
    playerUserStates: GameClientUserState[]
    onChangePerspective: (color: PlayerColor) => void
    numberOfActions: number
    currentActionIndex: number
    onSliderChangeActionIndex: (actionIndex: number) => void
    highlightData: ReplayHighlightData[]
    className?: string
    disableTooltips?: boolean | undefined
}

export const ReplayControlsContentMinimal = ({
    isPlaying,
    onTogglePlayback,
    onPreviousAction,
    onNextAction,
    currentPlayerPerspective,
    playerUserStates,
    onChangePerspective,
    numberOfActions,
    currentActionIndex,
    onSliderChangeActionIndex,
    highlightData,
    className,
    disableTooltips,
}: UIGameReplayControlsContentMinimalProps) => {
    const hasHighlightData = highlightData.length > 0

    return <div className={clsx(styles.replayControlsContainer, className)}>
        <ReplaySlider
            highlightData={highlightData}
            max={numberOfActions}
            onChange={onSliderChangeActionIndex}
            shouldShowHighlights={hasHighlightData}
            value={currentActionIndex}
        />
        <div className={clsx(styles.bottomMenu, styles.bottomMenuVisible)}>
            <div className={styles.controllerButtons}>
                <ControlButton
                    icon={IconRewind}
                    alt="strings:imgAlts.Rewind"
                    disabled={currentActionIndex <= -1}
                    onClick={onPreviousAction}
                    tooltipContent={<T id="strings:game.tooltips.replay.previousAction" />}
                    disableTooltip={disableTooltips}
                />
                {
                    isPlaying ? (
                        <ControlButton
                            icon={IconPause}
                            alt="strings:imgAlts.Pause"
                            onClick={onTogglePlayback}
                            tooltipContent={<T id="strings:game.tooltips.replay.playPause" />}
                            disableTooltip={disableTooltips}
                        />
                    ) : (
                        <ControlButton
                            icon={IconPlay}
                            alt="strings:imgAlts.Play"
                            onClick={onTogglePlayback}
                            tooltipContent={<T id="strings:game.tooltips.replay.playPause" />}
                            disableTooltip={disableTooltips}
                        />
                    )
                }
                <ControlButton
                    icon={IconFastForward}
                    alt="strings:imgAlts.FastForward"
                    onClick={onNextAction}
                    tooltipContent={<T id="strings:game.tooltips.replay.nextAction" />}
                    disableTooltip={disableTooltips}
                />
            </div>
            <AvatarList
                currentPlayerPerspective={currentPlayerPerspective}
                onChangePerspective={onChangePerspective}
                playerUserStates={playerUserStates}
            />
        </div>
    </div>
}
